<template>
  <!-- <ModalControl
    :is_visible="this.is_modal_open"
    @click="this.is_modal_open = false"
  >
    <div class="flex flex-col justify-center align-center items-center p-8">
      <p
        class="text-grey-darkest text-4xl align-center justify-center text-center"
      >
        Summary here
      </p>
    </div>
  </ModalControl> -->
  <div class="overflow-x-auto bg-grey-lighter rounded-xl mb-8">
    <table class="min-w-full" >
      <thead>
        <tr class="bg-grey-lighter">
          <th
            v-for="(display_header, header_index) in this.table_headers"
            :key="header_index"
            :class="[
              'py-5 px-10 text-grey-darker text-xl uppercase fixed-column',
              display_header === 'reference' ? 'text-left' : 'text-center',
              // 'text-center',
            ]"
          >
            {{
              display_header === "gross"
                ? "amount"
                : display_header === "balance_per_id"
                ? "balance"
                : display_header.replace(/_/g, " ")
            }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-if="!filterTableData || filterTableData.length === 0"
          @click="emitRowClick(row)"
        ></tr>
        <tr
          v-else
          v-for="(row, row_index) in filterTableData.slice(
            display_limit * current_page - display_limit,
            display_limit * current_page
          )"
          :key="row_index"
          :class="[row_index % 2 === 0 ? 'bg-white' : 'bg-grey-lighter']"
          style="height: 80px"
          @click="emitRowClick(row)"
        >
          <td
            v-for="(header, cell_index) in this.table_headers"
            :key="cell_index"
            :class="[
              'py-5 px-10',
              this.isDecimal(row[header]) ? 'text-right' : 'text-center',
              // header === 'reference' ? 'text-xl' : 'text-2xl',
              'text-xl',
            ]"
            :style="{ width: getColumnWidth(header) }"
          >
            <div v-if="header == 'amount'" class="text-right">
              <p
                v-if="
                  row['reference'] === 'BEGIN BALANCE' &&
                  table_data.indexOf(row) === table_data.length - 1
                "
              ></p>
              <p
                v-else-if="(row['credit'] != '0.00' && this.display_style === 'savings')"
                class="text-primary font-medium"
              >
                {{ formatCellValue(row["credit"]) }}
              </p>
              <p
                v-else-if="(row['debit'] != '0.00' && this.display_style === 'loans')"
                class="text-primary font-medium"
              >
                {{ formatCellValue(row["debit"]) }}
              </p>
              <p v-else-if="(row['debit'] != '0.00' && this.display_style === 'savings')" class="text-error font-medium">
                {{ "(" + formatCellValue(row["debit"]) + ")" }}
              </p>
              <p v-else-if="(row['credit'] != '0.00' && this.display_style === 'loans')" class="text-error font-medium">
                {{ "(" + formatCellValue(row["credit"]) + ")" }}
              </p>
              <p v-else class="text-grey font-medium">
                {{ formatCellValue(row["credit"]) || formatCellValue(row["debit"]) }}
              </p>
            </div>
            <div class="flex flex-row justify-between items-center">
              <span
                :class="[
                  'flex-grow',
                  header === 'balance' ||
                  header === 'debit' ||
                  header === 'credit' ||
                  header === 'gross' ||
                  header === 'balance_per_id'
                    ? 'text-right'
                    : header === 'date' ||
                      header === 'Recent Mature Date' ||
                      header === 'mature_date' ||
                      header === 'terms' ||
                      // header === 'reference' ||
                      header === 'tracking' ||
                      header === 'description'
                    ? 'text-center'
                    : 'text-left',
                  // header === 'credit' && this.display_style === 'savings'
                  //   ? 'text-error'
                  //   : header === 'debit' && this.display_style === 'savings'
                  //   ? 'text-primary'
                  //   : '',
                  // header === 'credit' && this.display_style === 'loans'
                  //   ? 'text-primary'
                  //   : header === 'debit' && this.display_style === 'loans'
                  //   ? 'text-error'
                  //   : '',
                ]"
                >{{ formatCellValue(row[header]) }}
              </span>
              <div
                class="flex-shrink-0 text-right"
                :style="{ width: '40px' }"
                v-if="header === 'balance_per_id' && show_row_button"
              >
                <IconControl id="forward_grey" :width="20" :height="20" />
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <div
      v-if="!filterTableData || filterTableData.length === 0"
      class="flex flex-col justify-center align-center items-center p-8 papsi-height"
    >
      <p
        class="text-grey-dark text-3xl align-center justify-center text-center italic"
      >
        No transactions found
      </p>
    </div>
  </div>
  <div>
    <div class="flex justify-between align-middle items-center">
      <div v-if="!this.getTotalPages == 0" class="flex flex-row">
        <ButtonControl
          text=""
          theme="pagination"
          class="mr-3"
          @click="changePage(1)"
        >
          <img
            :src="
              getIcon(current_page <= 1 ? 'first_page_disabled' : 'first_page')
            "
            width="50"
            alt=""
          />
        </ButtonControl>
        <ButtonControl
          text=""
          theme="pagination"
          class="mr-3"
          @click="changePage(current_page - 1)"
        >
          <img
            :src="getIcon(current_page <= 1 ? 'prev_disabled' : 'prev-green')"
            width="30"
            alt=""
          />
        </ButtonControl>
        <ButtonControl
          v-for="i in getPageRange"
          :key="i"
          :text="String(i)"
          :theme="i === current_page ? 'current_page' : 'pagination'"
          class="mr-3"
          @click="changePage(i)"
        />
        <ButtonControl
          text=""
          theme="pagination"
          @click="changePage(current_page + 1)"
        >
          <img
            :src="
              getIcon(
                this.current_page >= this.getTotalPages
                  ? 'next-grey'
                  : 'next-green'
              )
            "
            width="30"
          />
        </ButtonControl>

        <ButtonControl
          theme="pagination"
          @click="changePage(this.getTotalPages)"
          text=""
        >
          <img
            :src="
              getIcon(
                this.current_page == this.getTotalPages ||
                  this.getTotalPages == 0
                  ? 'last_page_disabled'
                  : 'last_page'
              )
            "
            width="50"
            alt=""
          />
        </ButtonControl>
      </div>

      <!-- <div
        v-if="this.show_result_count && !this.getTotalPages == 0"
        class="ml-auto"
      > -->
      <div class="ml-auto">
        <p class="text-grey-darker text-2xl">
          {{ $t("led003") }} {{ getResultsRange.start }}–{{
            getResultsRange.end
          }}
          {{ $t("led013") }} {{ getResultsRange.total }} {{ $t("led004") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonControl from "./ButtonControl.vue";
// import ModalControl from "./ModalControl.vue";
import IconControl from "./IconControl.vue";
import mixin from "@/mixins/controls.js";

export default {
  name: "v-table",
  mixins: [mixin],
  emits: ["rowclick"],
  components: {
    ButtonControl,
    // ModalControl,
    IconControl,
  },
  props: {
    table_data: {
      type: Array,
    },
    display_limit: {
      type: Number,
      default: 5,
    },
    display_style: {
      type: String,
      default: "savings",
      validator: (value) => ["savings", "loans"].includes(value),
    },
    show_pagination: {
      type: Boolean,
      default: true,
    },
    show_result_count: {
      type: Boolean,
      default: true,
    },
    show_row_button: {
      type: Boolean,
      default: false,
    },
    max_pages: {
      type: Number,
      default: 5,
    },
    table_headers: {
      type: Array,
      default: () => ["date", "description", "amount", "balance"],
    },
    show_all_transactions: {
      type: Boolean,
      default: false,
    },
    show_transaction_summary: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      current_page: 1,
      is_modal_open: false,
      column_widths: {
        date: "70px",
        // reference: "400px",
        amount: "300px",
        balance: "300px",
      },
    };
  },
  computed: {
    getTableHeaders() {
      if (this.table_data && this.table_data.length > 0) {
        const reordered_keys = ["date", "reference", "amount", "balance"];
        return reordered_keys;
      } else {
        return [];
      }
    },
    getResultsRange() {
      if (!this.filterTableData || this.filterTableData.length === 0) {
        return { start: 0, end: 0, total: 0 };
      }
      const start = (this.current_page - 1) * this.display_limit + 1;
      const end = Math.min(
        this.current_page * this.display_limit,
        this.filterTableData.length
      );
      const total = this.filterTableData.length;
      return { start, end, total };
    },
    getTotalPages() {
      return Math.ceil(this.filterTableData.length / this.display_limit);
    },
    getStartPage() {
      const page_difference = Math.floor(this.max_pages / 2);
      let start_page = Math.max(1, this.current_page - page_difference);
      let end_page = Math.min(
        this.getTotalPages,
        start_page + this.max_pages - 1
      );
      if (end_page - start_page < this.max_pages - 1) {
        start_page = Math.max(1, end_page - this.max_pages + 1);
      }
      return start_page;
    },
    getEndPage() {
      return Math.min(
        this.getTotalPages,
        this.getStartPage + this.max_pages - 1
      );
    },
    getPageRange() {
      let range = [];
      for (let i = this.getStartPage; i <= this.getEndPage; i++) {
        range.push(i);
      }
      return range;
    },
    filterTableData() {
      if (!this.table_data || this.table_data.length === 0) {
        return [];
      }

      if (this.show_all_transactions) {
        return this.table_data;
      }

      // extract month and year from last transaction date, then extract the last 6 months
      const active_months = new Set(
        [
          ...new Set(
            this.table_data.map(
              (row) =>
                `${new Date(row.date).getFullYear()}-${String(
                  new Date(row.date).getMonth() + 1
                ).padStart(2, "0")}`
            )
          ),
        ]
          .sort((a, b) => new Date(b) - new Date(a))
          .slice(0, 6)
      );

      return this.table_data.filter((row) => {
        const date = new Date(row.date);
        const extracted_date = `${date.getFullYear()}-${String(
          date.getMonth() + 1
        ).padStart(2, "0")}`; // check if the transaction date is within the last 6 months

        return (
          row.reference !== "BEGIN BALANCE" && active_months.has(extracted_date)
        );
      });
    },
  },
  methods: {
    getColumnWidth(header) {
      return this.column_widths[header] || "auto";
    },
    formatCellValue(value) {
      if (this.isDate(value)) {
        const [year, month, day] = value.split("-");
        return `${month}/${day}/${year}`;
      } else if (this.isDecimal(value)) {
        return this.formatAmount(value);
      }
      return value;
    },
    changePage(page) {
      if (page >= 1 && page <= this.getTotalPages) {
        this.current_page = page;
      }
    },
    emitRowClick(row) {
      this.$emit("rowclick", row);
    },
  },
};
</script>

<style scoped>
td {
  font-family: ui-monospace, sans-serif;
}

.fixed-column {
  width: 250px;
}

.papsi-height {
  height: 10rem;
}

.papsi-pagination {
  bottom: 12rem;
  left: 43rem;
}
</style>
